module.exports = __webpack_public_path__ + "static/media/menu-boczne-numery-alarm_BLUE.bf8a63cc.svg";